import React, { useEffect, useRef, useState } from "react"
import Body from "../../components/body/BodyPage"
import MainLinks from "../../components/navlinks/MainLinks"
import { useTranslation } from "react-i18next";
import AADiaLByName from "../../components/editviews/aagroup/AADialByName";
import {
    MDBAlert,
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBInput,
    MDBModalFooter
} from "mdb-react-ui-kit";
import AADialByNameAdd from "../popups/autoattendant/AADialByNameAdd";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import { deleteDirectory, getDirectoryAll } from "../../apiclients/streamsapi_bridge";
import DeleteAADirectory from "../popups/autoattendant/DeleteAADirectory";
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router";
import PopupLoader from "../popups/PopupLoader";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
function DialbyNameDirectoriesLanding() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [rowData, setRowData] = useState([]);
    const [aacode, setAACode] = useState(0);
    const [directoryid, setDirectoryId] = useState(0);
    const [isdeleteDir, setIsDeleteDir] = useState(false);
    const [deleteUserFlag, setDeleteUserFlag] = useState(false);
    const dtogglePopup = () => setIsDeleteDir(!isdeleteDir);
    const [successMessage, setSuccessMessage] = useState("");
    const [message, setMessage] = useState([]);
    const [rerender, setRerender] = useState(false);
    const addDirectoryRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const navigate = useNavigate();
    const [warningEdit, setwarningEdit] = useState(false);
    const toggleWarning = () => setwarningEdit(!warningEdit);
    const [deleteWarning, setdeleteWarning] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false); 
      const searchRef = useRef(null);
     useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
    function handleClick() {
        addDirectoryRef.current.click();
    }

    function deleteSelectedUser(event, infoObj) {
        event.preventDefault();
        event.stopPropagation();
        validateDeleteDirectory(infoObj);
        // setDirectoryId(infoObj.id);
        // dtogglePopup();

    }

    async function validateDeleteDirectory(infoObj) {
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let saverep = await deleteDirectory(JSON.parse(sessionStorage.getItem("admin_session")).siteid, infoObj.id, true);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        console.log("saverepeMsg :::::::: " + JSON.stringify(saverepeMsg));
        if (saverep.status === 200) {
            if (saverepeMsg.validation_failed) {
                setdeleteWarning(saverepeMsg.validation_failed);
                setwarningEdit(true);
            } else {
                setDirectoryId(infoObj.id);
                dtogglePopup();
            }

        } else {

        }

    }



    useEffect(() => {
        if (successMessage) {
            setMessage(true);
            setTimeout(() => {
                setMessage(false);
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    function processUserDtlsFraming(groupInfo) {
        let proccessdRows = [];
        groupInfo?.forEach((infoObj) => {
            let processedRow = {
                id: infoObj.id,
                name: infoObj.name,
                type: infoObj.type === 0 ? "Include" : "Exclude",
                directoryInfo: infoObj,
                delete: (
                    <div className="ms-4 w-40">
                        {!(infoObj?.is_primary && infoObj?.is_primary === 1) && (
                            <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
                                <i
                                    className="fas fa-times text-primary"
                                    href="#"
                                    onClick={(e) => deleteSelectedUser(e, infoObj)}
                                    defaultValue={infoObj.id}
                                    target="_new"
                                />
                            </div>
                        )}
                    </div>
                )
            };
            proccessdRows.push(processedRow);
        });
        setRowData(proccessdRows);
        setFilteredRows(proccessdRows)
        setDataLoaded(true)
    }


    useEffect(() => {
        async function getAllAADirectories() {
            const response = await getDirectoryAll(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.DIAL_BY_NAME_DIR_LINK
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
            }
            // alert(`all AA Directories ::::: `+JSON.stringify(rawData?.directoryList));
            console.log(`all AA Directories ::::: ` + JSON.stringify(rawData.data));
            const directoryList = rawData?.data ?? [];
            processUserDtlsFraming(directoryList);
            setRerender(false);
        }

        getAllAADirectories();


    }, []);





    let columnsInfo = [
        { label: "Name", field: "name", sort: true },
        { label: "Type", field: "type", sort: true },
        { label: "Remove", field: "delete", sort: false },
    ];

    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(rowData, searchValue, UIConstant.DIALBY_NAME_DIRECTORIES);

        setFilteredRows(filtered);
    };


    function showThisInf(tdata) {
        if (tdata.directoryInfo && tdata.directoryInfo.is_primary !== 1) {
            navigate("/dailbydirectoriessettings", {
                state: tdata.directoryInfo,
            });
        } else {
            return;
        }
    }

    const [centredModal, setCentredModal] = useState(false);

    const toggleShow = () => setCentredModal(!centredModal);

    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={31}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t("directories")}
                                        </h5>
                                        <p className="text-secondary">
                                            Here you can manage directory lists used in Luna and Auto Attendants.  You can create an exclude list which will remove those users from all the users.  You can create an include list which will only include the users in the list.
                                        </p>
                                    </div>
                                    <div className="card-body px-0">
                                        <h5 className="tabcontent actionbar">
                                            <MDBBtn className="btn btn-primary green-button display-inline float-right" onClick={toggleShow} >
                                                <MDBIcon fas icon="plus" size="sm" /> {t("addDirectoryList")}
                                            </MDBBtn>
                                        </h5>
                                         <div className='mb-2 mt-0 position-relative w-auto'>
                                            <MDBInput
                                                label="Search"
                                                value={searchValue}
                                                ref={searchRef}
                                                onChange={(e) => handleManualSearch(e.target.value)}
                                            />
                                            <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                        </div>
                                        <MDBDatatable
                                            className="table2column actioncolumn"
                                            key={searchValue}
                                            // search
                                            entries={50}
                                            maxHeight="63vh"
                                            sortField="Name"
                                            sortOrder="asc"
                                            searchInputProps={[]}
                                            data={{
                                                columns: columnsInfo,
                                                rows: filteredRows
                                            }}
                                            hover
                                            onRowClick={(event) =>
                                                showThisInf(event)
                                            }
                                        />
                                        {centredModal && (
                                            <PopupLoaderNew
                                                size="md"
                                                className="modal-md"
                                                title={t("addDirectoryList")}
                                                content={
                                                    <AADialByNameAdd
                                                        onClose={toggleShow}
                                                        ref={addDirectoryRef}
                                                        setIsloading={setisLoading}

                                                    />
                                                }
                                                onShow={setCentredModal}
                                                onClose={toggleShow}
                                                onSave={handleClick}
                                                isloading={isLoading}
                                                flag={1}
                                            />
                                        )}

                                        {isdeleteDir && (
                                            <PopupLoaderNew
                                                title={"Remove Dial by Name Directory"}
                                                content={
                                                    <DeleteAADirectory
                                                        directoryid={directoryid}
                                                        // groupcode={props.aagcode}
                                                        onClose={dtogglePopup}
                                                        setRerender={setRerender}
                                                        setSuccessMessage={setSuccessMessage}
                                                        ref={addDirectoryRef}
                                                        setIsloading={setisLoading}
                                                    />
                                                }
                                                onShow={setIsDeleteDir}
                                                onClose={dtogglePopup}
                                                onSave={handleClick}
                                                isloading={isLoading}
                                                flag={4}
                                            />
                                        )}

                                        {successMessage && (
                                            <MDBAlert
                                                open
                                                className="alert-center"
                                                color="success"
                                                autohide
                                                position="bottom-right"
                                                delay={10000}
                                            >
                                                <i className="fas fa-check-circle me-3"></i>
                                                <span className="alert-msg">{successMessage}</span>
                                            </MDBAlert>
                                        )}

                                        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                                            Remove
                                        </Tooltip>

                                    </div>
                                </div>
                            </section>
                            {warningEdit && (
                                <PopupLoader
                                    title={"Warning"}
                                    content={
                                        <>
                                            {/* <strong>{t("select911loc")}</strong> */}
                                            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                                                <MDBIcon
                                                    fas
                                                    icon="exclamation-triangle"
                                                    className="me-3 fs-5 mt-1"
                                                    color="warning"
                                                />
                                                <p>
                                                    {deleteWarning}

                                                </p>
                                            </div>

                                            <MDBModalFooter className="p-0 pt-2 mt-3">
                                                <MDBBtn
                                                    onClick={toggleWarning}
                                                >
                                                    {" "}
                                                    {t("OK")}{" "}
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </>
                                    }
                                    className={""}
                                    onShow={setwarningEdit}
                                    onClose={toggleWarning}
                                />
                            )}


                        </>
                    }
                />


            </>
        </React.Fragment>
    )
}
export default DialbyNameDirectoriesLanding
